import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-breadcrumb-card',
  templateUrl: './mcommerce-breadcrumb-card.component.html',
  styleUrls: ['./mcommerce-breadcrumb-card.component.scss']
})
export class McommerceBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
